module.exports = __webpack_public_path__ + "img/chat-user.1f644e87.png";